import type { Service, ServiceGroup } from '@/types';

export const formatServiceLabel = (
  group: Pick<ServiceGroup, 'name' | 'services'>,
  service: Pick<Service, 'variationName'>,
) =>
  group.services.length > 1 && service.variationName
    ? `${group.name} — ${service.variationName}`
    : group.name;
